import theme from "../theme";

const getProjectColor = (projectId) => {
  const numberOfColors = theme.colors.swatches.length;
  return theme.colors.swatches[projectId % numberOfColors];
};

export default getProjectColor;
